var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formValidate",
      attrs: {
        model: _vm.params,
        rules: _vm.rules,
        "label-width": "180px",
        "label-position": "right"
      }
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.account"), prop: "loginName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("user.inputAccount"),
                      disabled: _vm.isUpdate
                    },
                    model: {
                      value: _vm.params.loginName,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "loginName", $$v)
                      },
                      expression: "params.loginName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.userName"), prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("user.inputName") },
                    model: {
                      value: _vm.params.name,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "name", $$v)
                      },
                      expression: "params.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              !_vm.isUpdate
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("user.password"),
                        prop: "password"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "password",
                          placeholder: _vm.$t("user.inputPwd")
                        },
                        model: {
                          value: _vm.params.password,
                          callback: function($$v) {
                            _vm.$set(_vm.params, "password", $$v)
                          },
                          expression: "params.password"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              !_vm.isUpdate
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("user.confirmedPwd"),
                        prop: "secondPwd"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "password",
                          placeholder: _vm.$t("user.input2ndPwd")
                        },
                        model: {
                          value: _vm.params.secondPwd,
                          callback: function($$v) {
                            _vm.$set(_vm.params, "secondPwd", $$v)
                          },
                          expression: "params.secondPwd"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.email"), prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("user.inputEmail") },
                    on: { input: _vm.op },
                    model: {
                      value: _vm.params.email,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "email", $$v)
                      },
                      expression: "params.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.phone"), prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("user.inputPhone") },
                    model: {
                      value: _vm.params.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "phone", $$v)
                      },
                      expression: "params.phone"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.sex"), prop: "sex" } },
                [
                  _c("zk-dictionary-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "sex",
                      clearable: "",
                      placeholder: _vm.$t("common.select")
                    },
                    model: {
                      value: _vm.params.sex,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "sex", $$v)
                      },
                      expression: "params.sex"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.nickName"), prop: "nickName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("user.inputNickName") },
                    model: {
                      value: _vm.params.nickName,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "nickName", $$v)
                      },
                      expression: "params.nickName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.status"), prop: "status" } },
                [
                  _c("zk-dictionary-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "status",
                      placeholder: _vm.$t("common.select")
                    },
                    model: {
                      value: _vm.params.status,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "status", $$v)
                      },
                      expression: "params.status"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("user.department"), prop: "deptName" }
                },
                [
                  _c("el-tree", {
                    ref: "deptTree",
                    attrs: {
                      data: _vm.treeData,
                      props: _vm.defaultProps,
                      "node-key": "id",
                      "show-checkbox": "",
                      "default-expanded-keys": _vm.deptArr
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b460582", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b460582","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/userSaveOrUpdate/src/main.vue
// module id = null
// module chunks = 